import client from '../../base-api';

const serviceURL = '/portal/case-management-coaching';

const portalCaseManagementCoachingService = {

    getFirstInterviewData(coachingId: number) {
        return client.get(`${serviceURL}/first-interview/${coachingId}`);
    },

    // First interview
    createFirstInterview(data: any) {
        return client.post(`${serviceURL}/first-interview-create`, data);
    },
    updateFirstInterview(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/first-interview-update/${firstInterviewId}`, data);
    },
    updateFirstInterviewAsAdmin(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/first-interview-update-as-admin/${firstInterviewId}`, data);
    },

    // Protocol
    getProtocolList(coachingId: number) {
        return client.get(`${serviceURL}/protocol-list/${coachingId}`);
    },
    getProtocol(protocolId: number) {
        return client.get(`${serviceURL}/protocol/${protocolId}`);
    },
    postProtocol(protocolData: any) {
        return client.post(`${serviceURL}/protocol-create`, protocolData);
    },
    updateProtocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-update/${protocolId}`, protocolData);
    },
    updateProtocolAsAdmin(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-update-as-admin/${protocolId}`, protocolData);
    },
    postProtocolNote(noteData: any) {
        return client.post(`${serviceURL}/protocol-note-create`, noteData);
    },
    putProtocolNote(noteData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-note-update/${protocolId}`, noteData);
    },
    protocolDelete(protocolId: number) {
        return client.delete(`${serviceURL}/protocol-delete/${protocolId}`);
    },


    // Meeting data history list
    getMeetingDataHistoryList(meetingId: number) {
        return client.get(`${serviceURL}/meeting-history/${meetingId}`);
    },


    // Invitation to first appointment
    getInvitationsList(coachingId: number) {
        return client.get(`${serviceURL}/invitation-to-first-appointment-list/${coachingId}`);
    },
    getInvitation(invitationId: number) {
        return client.get(`${serviceURL}/invitation-to-first-appointment/${invitationId}`);
    },
    putInvitation(invitationData: any, invitationId: number) {
        return client.put(`${serviceURL}/invitation-to-first-appointment-update/${invitationId}`, invitationData);
    },
    postInvitation(invitationData: any) {
        return client.post(`${serviceURL}/invitation-to-first-appointment-create`, invitationData);
    },
    invitationDelete(invitationId: number) {
        return client.delete(`${serviceURL}/invitation-to-first-appointment-delete/${invitationId}`);
    },

    // Final report
    getFinalReport(coachingId: number) {
        return client.get(`${serviceURL}/final-report/${coachingId}`);
    },
    submitFinalReport(data: any) {
        return client.post(`${serviceURL}/final-report`, data);
    },

    // Confirmation billing report
    getConfirmationBillingReport(coachingId: number) {
        return client.get(`${serviceURL}/confirmation-billing-report/${coachingId}`);
    },
    submitConfirmationBillingReport(data: any) {
        return client.post(`${serviceURL}/confirmation-billing-report`, data);
    },


    // Digital signature
    saveDigitalSignature(data: any) {
        return client.post(`${serviceURL}/digital-signature`, data );
    },


    // Documents
    getDocuments(coachingId: number) {
        return client.get(`${serviceURL}/documents/${coachingId}`);
    },
    submitDocuments(data: any) {
        return client.post(`${serviceURL}/documents`, data);
    },


    // REMOTE DIGITAL SIGNATURE
    createCmcAccessTokenRemoteDigitalSignature(data: any) {
        return client.post(`${serviceURL}/generate-access-token`, data);
    },
    getCmcRemoteMeetings(token: string) {
        return client.get(`${serviceURL}/remote-meetings/${token}`);
    },
    saveCmcRemoteDigitalSignature(data: any) {
        return client.post(`${serviceURL}/remote/digital-signature`, data);
    },

}

export default portalCaseManagementCoachingService;